import { SegmentedControl as SegCtrl } from './SegmentedControl';
import { SEGMENTED_CONTROL_SIZES, SegmentedControlNoSizeProps } from './types';

export * from './types';
export const SegmentedControl = SegCtrl;

export const SmallSegmentedControl = (props: SegmentedControlNoSizeProps) => (
  <SegCtrl {...props} size={SEGMENTED_CONTROL_SIZES.SMALL} />
);

export const MediumSegmentedControl = (props: SegmentedControlNoSizeProps) => (
  <SegCtrl {...props} size={SEGMENTED_CONTROL_SIZES.MEDIUM} />
);

export const LargeSegmentedControl = (props: SegmentedControlNoSizeProps) => (
  <SegCtrl {...props} size={SEGMENTED_CONTROL_SIZES.LARGE} />
);
